import { Typography } from '@mui/material';
import { t } from 'i18next';
import { YellowWarningIcon } from '../../../assets/images';
import { MuiButton, MuiPopup, MuiStack } from '../../../components';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import { useAppSelector } from '../../../store/hooks';
function FinalInspectorSendBackPopup(props) {
    var isOpen = props.isOpen, onClosePopup = props.onClosePopup, onClickConfirmBtn = props.onClickConfirmBtn, onClickCancelBtn = props.onClickCancelBtn;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            onClosePopup(false);
        },
        padding: "15px 0px 0px 15px",
        headerIcon: YellowWarningIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Send back for rework")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        marginTop: 2
    }, t("Are you sure you want to send this vehicle to rework?")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        marginTop: 3
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "yes-btn",
        size: "large",
        fullWidth: true,
        name: t("Confirm"),
        variant: "contained",
        onClick: onClickConfirmBtn
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "no-btn",
        size: "large",
        fullWidth: true,
        name: t("Cancel"),
        variant: "outlined",
        style: {
            border: '1px solid #DEE4EB',
            color: '#6A7682'
        },
        onClick: onClickCancelBtn
    }))));
}
export default FinalInspectorSendBackPopup;
